<div class="toast-wapper white-bg radius-m" [ngClass]="toastClass">
  <div class="toast-content p-2">
    <div class="content span-m primary-text">{{ data.text }}</div>
    <img class="close-toast icon-m" (click)="close()" src="assets/close-dialog.svg">
  </div>
  <div class="progress_bar" #element>
  </div>
</div>  